<template>
  <div class="home">
    <Navbar :is-active="1"></Navbar>
    <div class="body">
      <CommercialSidebar active="descuentos" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Descuentos</h2>
        </div>
        <div>
          
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de Descuento" style="height: 3.5rem;" v-model="discount_code" @keyup="search" @keypress="onlynumber(e)" />
          <select v-model="discount_type" style="height: 3.5rem;" @change="search">
            <option selected="selected" value="">Tipo de descuento</option>
            <option value="1">Monto</option>
            <option value="2">Porcentaje</option>
          </select>
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label>Fecha inicio</label>
            <input type="date" v-model="discount_f_inicio" @change="search"/>
          </div>
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label>Fecha fin</label>
            <input type="date" v-model="discount_f_fin" @change="search" />
          </div>
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label>Fecha registro</label>
            <input type="date" v-model="created_at" @change="search"/>
          </div>
          <select v-model="discount_status" style="height: 3.5rem;" @change="search">
            <option selected="selected" value="">Estado</option>
            <option value="1">Acivado</option>
            <option value="0">Desactivado</option>
          </select>
          <input type="text" placeholder="Nombre de Sucursal" v-model="branch_name" @keyup="search" />
          <select v-model="product_type" @change="search">
            <option selected="selected" value="">Tipo de Producto</option>
            <option v-for="valor of type" :key="valor.name" :value="valor.id">{{ valor.name}}</option>
          </select>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>
        </div>
        <div class="page__buttons">
          <button @click="createDiscount()" class="button">
            Nuevo Descuento <i class="fas fa-plus"></i>
          </button>
          <button @click="importDiscount()" class="button">
            Carga Masiva <i class="fas fa-upload"></i>
          </button>
          <ButtonExport
            :data="discounts_export"
            :columns="columns"
            :sheet-name="'Datos Descuentos'"
            :file-name="'Reporte Descuentos'"
          />
        </div>
        <div class="page__table" style=" overflow: auto">
          <div class="table-headers">
            <p v-for="({ label }, index) of columns" :key="label">
              {{ label }}
            </p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="discount of discounts" :key="discount.id">
              <p>{{ discount.discount_name }}</p>
              <p>{{ discount.discount_code }}</p>
              <p>
                {{ dateFormat(discount.discount_f_inicio) }}
              </p>
              <p>
                {{ dateFormat(discount.discount_f_fin) }}
              </p>
              <p>
                {{ dateFormat(discount.created_at) }}
              </p>
              <p>
                {{ dateFormat(discount.updated_at) }}
              </p>
              <div class="dropdown"> 
                  <button class="button" @click="show('id-dropdown-content'+discount.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+discount.id)"  class="dropdown-content" :id="'id-dropdown-content'+discount.id">
                      <router-link :to="{ path: '/Client/ShowDiscount', query: { id: discount.id }}" class="dropdown-item">
                        <i class="far fa-eye " ></i> Ver Detalle
                      </router-link>
                      <div class="dropdown-item-special">
                        Activado
                        <input
                            :id="'check_'+discount.id"
                            type="checkbox"
                            :checked="(discount.discount_status === 1)"
                            class="dropdown-checkbox"
                            @change="activateDiscount($event, discount.id)"
                        />
                        <label class="wrapper" :for="'check_'+discount.id">
                          <span class="circle"></span>
                        </label>
                      </div>
                  </div>
                </div>
            </div>
             <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
        <vue-final-modal v-if="dataModal" v-model="showModal"  classes="modal-container" content-class="modal-content">
          <h2>Datos Producto: </h2>
          <div id="columnas">
          </div>

          <div class="page__table">
            <h4>Sucursales</h4>
            <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
              <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
                <input @keyup="searchDiscount" type="text" v-model="search_discount" placeholder="Buscar Sucursal" style="padding: 0px 0px;">
                <i class="fas fa-search"></i>
              </div>
            </section>
          
            <div class="page__pagination" style="padding-top: 2%;">
              <Pagination
                  :data="paginationDiscount"
                  v-on:changePage="handleClickInDiscount"
              />
            </div>

          </div>
          <div class="page__buttons" style="padding-top: 2%;">
            <button style="background: #ff3128; width: 250px;padding: 15px 20px;border-radius: 15px;font-size: 17px;color: #fff;border: none;display: flex;align-items: center;justify-content: space-between;" @click="this.showModal = false">
              <span>Cerrar</span>
              <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </vue-final-modal>
        {{modal}}
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar.vue'
  import { dateFormat } from '@/utils/formats'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Dropdown from '@/components/Dropdown.vue'
  import Pagination from '@/components/Pagination.vue'
  import OpenArrow from '@/components/OpenArrow.vue'
  import CommercialSidebar from '@/components/CommercialSidebar.vue'
  import { VueFinalModal } from 'vue-final-modal'
  import $ from 'jquery'

  export default {
    name: 'Home',
    components: {
      Navbar,
      ButtonExport,
      Dropdown,
      Pagination,
      OpenArrow,
      CommercialSidebar,
      VueFinalModal
    },
    data() {
      return {
        role: localStorage.getItem('role'),
        url_importar: '',
        discounts: [],
        type: 'discount',
        discount_code: '',
        discount_f_inicio: '',
        discount_f_fin: '',
        discount_status: '',
        product_type: '',
        branch_name: '',
        created_at: '',
        brand: '',
        search_discount: '',
        pagination: [],
        fecha: '',
        dis: '',
        dataModal: null,
        showModal: false,
        fecha_fin: '',
        discounts_export: [],
        paginationDiscount: [],
        discount_type: '',
        empty: false,
        timeout: null,
        columns: [

          { label: 'Nombre de Descuento', field: 'discount_name' },
          { label: 'Código de Referencia', field: 'discount_code' },
          {
            label: 'Fecha Inicio',
            field: 'discount_f_inicio',
            dataFormat: this.dateFormat
          },
          {
            label: 'Fecha Fin',
            field: 'discount_f_fin',
            dataFormat: this.dateFormat
          },
          {
            label: 'Fecha Registro',
            field: 'created_at',
            dataFormat: this.dateFormat
          },
          {
            label: 'Fecha de Actualización',
            field: 'updated_at',
            dataFormat: this.dateFormat
          }
        ]
      }
    },
    methods: {
      onlynumber(evt){
        evt = (evt) ? evt : window.event
        const charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      backCompany(){
        this.$router.push('/comercial')
      },
      activateDiscount(e, id){
        let data = {
          discount_status: (e.target.checked) ? 1 : 0
        }
        axios.put('general/discount/'+id, data)
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: (e.target.checked) ? 'Activado correctamente': 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      },
      openModal(divID, page = 1, search = ''){
        if(!divID){
          this.dis = divID
          this.showModal = true
      }
      },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      handleClickInParent: function(page) {
        this.getall(page)
      },
      handleClickInDiscount: function(page){
        this.openModal(null, page, this.search_discount)
      },
      dateFormat,
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      clean_filter(){
        this.discount_code = '';
        this.discount_type = '';
        this.discount_f_inicio = '';
        this.discount_f_fin = '';
        this.created_at = '';
        this.discount_status = '';
        this.branch_name = '';
        this.product_type= '';
        this.getall()
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          let paramSearch = {
            discount_code: self.discount_code,
            discount_type: self.discount_type,
            discount_f_inicio: self.discount_f_inicio,
            discount_f_fin: self.discount_f_fin,
            created_at: self.created_at,
            discount_status: self.discount_status,
            branch_name: self.branch_name,
            product_type: self.product_type,
          }
          this.getall(1, paramSearch)
        }.bind(this), 500);
      },
      async getType(){
        await axios.get('general/elements/type', { params: {
            product_company_id: localStorage.getItem('company_id')
          }
        }).then(res => {
          this.type = res.data.data
        })
      },
     async getall(page = 1, paramSearch = {}) {
        await axios.get('general/discount', {params: {
            page: page,
            discount_company_id:localStorage.getItem('company_id'),
            discount_code: (paramSearch.discount_code) ? paramSearch.discount_code : null,
            discount_type: (paramSearch.discount_type) ? paramSearch.discount_type : null,
            discount_f_inicio: (paramSearch.discount_f_inicio) ? paramSearch.discount_f_inicio : null,
            discount_f_fin: (paramSearch.discount_f_fin) ? paramSearch.discount_f_fin : null,
            fecha: (paramSearch.created_at) ? paramSearch.created_at : null,
            discount_status: (paramSearch.discount_status) ? paramSearch.discount_status : null,
            branch_name: (paramSearch.branch_name) ? paramSearch.branch_name : null,
            product_type: (paramSearch.product_type) ? paramSearch.product_type : null,
        }}).then( res => {
          this.url_importar = res.data.url
          if (res.data.data.total > 0){
            this.discounts = res.data.data.data
            this.pagination = res.data.data
            this.discounts_export = res.data.export
            this.empty = false
          }else{
            this.discounts = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      showDiscount(id) {
        this.$router.push({ path: '/Client/ShowDiscount', query: { id: id } })
      },
      createDiscount() {
        this.$router.push('/client/adddiscount')
      },
      async importDiscount() {
        const { value: file } = await this.$swal({
          title: 'IMPORTAR DESCUENTOS',
          html: 'descarga el formato <a href="'+this.url_importar+'">aquí</a><br><br><p>Nota:<br> El archivo debe ser en formato .xlsx y con el nombre fm_import_discount.xlsx</p>',
          input: 'file',
          inputAttributes: {
            accept: '.xlsx',
            'aria-label': ''
          },
          showCancelButton: true,
          confirmButtonText: 'Importar',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#ff3128',
          confirmButtonColor: '#32ba7c',
          showLoaderOnConfirm: true
        })

        if (file) {
          let self = this
          const reader = new FileReader()
          const formData = new FormData();
          formData.append('file', file);
          formData.append('company_id', localStorage.getItem('company_id'))


          reader.onload = async e => {
            const response = await axios.post('general/discount/import', formData).then(
                res => {
                  this.mensaje = ''
                  if (res.data.success){
                    let fl = 0
                    Object.entries(res.data.data).forEach(item=>{
                      if (item[1].mensaje){
                        let color = ''
                        if (!item[1].status){
                          color = 'red'
                          fl++
                        }
                        this.mensaje += '<p style="color:'+color+'">'+item[1].mensaje + '</p>'
                      }
                    })
                    let sms = ''
                    let icon = ''
                    if (Object.entries(res.data.data).length === fl){
                      sms = 'No se importó porque el archivo tiene errores'
                      icon = 'error'
                    }else if (fl===0){
                      sms = 'Se importó correctamente'
                      icon = 'success'
                    }else{
                      sms = 'Se importó pero algunas filas tienen errores, por favor revisar los registros de resultado'
                      icon = 'warning'
                    }

                    this.getall()
                    this.$swal({
                      position: 'center',
                      icon: icon,
                      title: sms,
                      html: '<div style="max-height: 200px; min-height: 30px">'+this.mensaje+'</div>',
                      showConfirmButton: true,
                      confirmButtonColor: '#32ba7c',
                      confirmButtonText: 'Aceptar'
                    })
                  }else {
                    this.$swal({
                      position: 'center',
                      icon: 'error',
                      title: 'Ocurrio un error',
                      showConfirmButton: false,
                      timer: 2000
                    })
                  }
                }
            ).catch(
                function (error) {
                  console.log(error);
                  self.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Formato Invalido',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
            )
          }



          // reader.onload = async e => {
          //   const response = await axios.post('general/discount/import', formData)
          // }
          reader.readAsDataURL(file)
        }
      }
    },
    created() {
      this.company_name = localStorage.getItem('company_name');
      this.getall()
      this.getType()
    }
  }
</script>

<style scoped>
  /*------NAVBAR------*/
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }

  .home .navbar {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
  }

  .home .navbar__left {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home .navbar__left img {
    width: 130px;
  }

  .home .navbar__center {
    width: 70%;
    height: 100%;
  }

  .home .navbar__center ul {
    width: 100%;
    height: 100%;
    display: flex;
    list-style: none;
    display: flex;
    justify-content: flex-start;
  }
  .home .navbar__center ul li {
    text-decoration: none;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
  }

  .home .navbar__center ul li::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 4px;
    background-color: #ff3128;
    transition: 0.3s ease;
  }
  .home .navbar__center ul li:hover {
    color: #ff3128;
  }
  .home .navbar__center ul li:hover::before {
    width: 100%;
  }

  .home .navbar__right {
    display: flex;
  }
  .home .navbar__right .profile {
    display: flex;
    width: 300px;
    height: 100%;
  }

  .home .navbar__right .profile__detail {
    width: 220px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 5px;
  }
  .home .navbar__right .profile__detail p {
    margin: 0;
  }
  .home .navbar__right .profile__detail span {
    color: #938f8f;
    font-weight: 300;
  }

  .home .navbar__right .profile__icon,
  .home .navbar__right .profile__logout {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    color: #ff3128;
    cursor: pointer;
  }
  /*------NAVBAR------*/

  /*-------------------------*/
  a:hover {
    text-decoration: none;
  }
  /*-------------------------*/

  /*------BODY------*/

  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    min-height: 87vh;
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }
  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }
  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 40px;
  }
  .body__containt .page__filters input {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }
  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #32ba7c;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(3) {
    background: #262626;
  }
  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }
  .body__containt .page__table .table-headers {
    width: 115%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
  .body__containt .page__table .table-body {
    width: 115%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    height: 60px;
    border-radius: 15px;
    display: flex;
    transition: 0.3s ease;
  }
  .body__containt .page__table .table-body .data:hover {
    background: #ffeeed;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
  }
  .body__containt .page__table .table-body .data p:nth-last-child(1) {
    cursor: pointer;
  }
  .body__containt .page__table .table-body .data p:nth-last-child(1) {
    cursor: pointer;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
    .body__sidebar.open{
    display: none;
  }
  /*------BODY------*/
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 7rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
#columnas{
  column-count:3;
  column-gap:40px;
  column-rule:4px dotted gray;
}
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 60% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 25px;
    margin-top: -19px;
    margin-right: -5px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
}
</style>
